module.exports = __webpack_public_path__ + "img/Blue.25c3da5f.png";